import { PayloadApiError } from '@/core/api';

const MAX_UPLOAD_SIZE_REGEX = /(?:maximum|max)\s+size|20\s?mb/i;

const extractErrorMessages = (errors: unknown[]): string[] =>
  errors
    .map((entry) => {
      if (!entry) return '';
      if (typeof entry === 'string') return entry;
      if (typeof entry === 'object' && 'message' in entry) {
        return String((entry as { message?: unknown }).message ?? '');
      }
      return String(entry);
    })
    .filter(Boolean);

export const isFileTooLargeError = (error: unknown): boolean => {
  if (error instanceof PayloadApiError) {
    if (error.statusCode === 413) {
      return true;
    }

    const errors = Array.isArray(error.response?.errors) ? error.response.errors : [];
    const messages = extractErrorMessages(errors);
    return messages.some((message) => MAX_UPLOAD_SIZE_REGEX.test(message));
  }

  if (error && typeof error === 'object' && 'message' in error) {
    return MAX_UPLOAD_SIZE_REGEX.test(String((error as { message?: unknown }).message ?? ''));
  }

  return false;
};

export const resolveFileUploadErrorMessage = (
  error: unknown,
  t: (key: string) => string,
  fallbackKey: string
) => {
  if (isFileTooLargeError(error)) {
    return t('operations.toasts.fileTooLarge');
  }

  return t(fallbackKey);
};
